var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoDependance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "picto_d\\xE9pendance_-_biens_vendus",
    "data-name": "picto d\\xE9pendance - biens vendus",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.453,
    height: 12.814,
    viewBox: "0 0 16.453 12.814",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_392",
    "data-name": "Trac\\xE9 392",
    d: "M15.931,3.2h-.325L8.355.08H8.243L.83,3.2H.51a.5.5,0,0,0-.51.51.51.51,0,0,0,.51.5H.97v8.339a.353.353,0,0,0,.348.342H15.141a.353.353,0,0,0,.348-.342V4.235h.46a.493.493,0,0,0,.5-.5A.561.561,0,0,0,15.931,3.2Zm-8.081,0H5.54L7.851,1.05Zm.7-2.075,2.282,2.1H8.569Zm-.7,3.112v7.991H4.8V4.235Zm.7,0h3.112v7.991H8.569ZM11.569,3.2,9.584,1.353,13.873,3.2ZM6.729,1.4,4.778,3.2H2.563ZM4.11,4.235v7.991H1.682V4.235Zm10.655,7.991H12.337V4.235h2.423Z",
    transform: "translate(0 -0.08)",
    fill: "#616a7d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoDependance);
export default __webpack_public_path__ + "static/media/picto_dependance.460456a4.svg";
export { ForwardRef as ReactComponent };